/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_View_BoardInputs */

const cs_tasks_view_board = /** @type {(inputs: Tasks_View_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nástěnka`)
};

const en_tasks_view_board = /** @type {(inputs: Tasks_View_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Board`)
};

/**
* | output |
* | --- |
* | "Board" |
*
* @param {Tasks_View_BoardInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_view_board = /** @type {((inputs?: Tasks_View_BoardInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_View_BoardInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_view_board(inputs)
	return cs_tasks_view_board(inputs)
});